import React from "react";

import TableCheckbox from "../../components/tableCheckbox";

import styles from "../matchReport.module.scss";

const fieldTypesColumn = () => ({
	Header: ({ getToggleAllRowsSelectedProps }) => {
		return (
			<>
				Field Types That Matched
				<TableCheckbox
					id="allFieldTypes"
					label=" "
					{...getToggleAllRowsSelectedProps()}
				/>
			</>
		);
	},
	accessor: "id",
	id: "selection",
	classNameCell: `${styles.fieldTypesCell}`,
	classNameHeader: `${styles.fieldTypesCellHeader} ${styles.tableHeader}`,
	Cell: ({ row }) => {
		const matchedFields = row.original?.matched_fields?.map((name, index) =>
			row.original?.matched_fields.length - 1 === index
				? name
				: `${name}${", "}`,
		);
		return (
			<div className="d-flex justify-content-between">
				<p className="mr-3">{matchedFields || ""}</p>
				<TableCheckbox
					label=""
					id={row.id}
					{...row.getToggleRowSelectedProps()}
				/>
			</div>
		);
	},
	disableSortBy: true,
});

export default fieldTypesColumn;
